import lampsIcon from "../../Images/EssentialLoads/lamps_icon.png";
import Printers from "../../Images/EssentialLoads/printer.png";
import CflLampsIcon from "../../Images/EssentialLoads/lamps_cfl_icon.png";
import LedLampsIcon from "../../Images/EssentialLoads/lamps_led.png";
import laptopIcon from "../../Images/EssentialLoads/laptop.png";
import ServersIcon from "../../Images/EssentialLoads/servers.png";
import TelevisionIcon from "../../Images/EssentialLoads/televsion.png";
import TubeLightIcon from "../../Images/EssentialLoads/tubelight.png";
import KitchenIcon from "../../Images/EssentialLoads/kitchen.png";
import DesktopIcon from "../../Images/EssentialLoads/desktop.png";
import fansIcon from "../../Images/EssentialLoads/fans.png";
import itPeripheralsIcon from "../../Images/EssentialLoads/it_periperals.png";
import geyser from "../../Images/Non-EssentialLoads/geyzer.png";
import AC from "../../Images/Non-EssentialLoads/ac.png";
import dishWasher from "../../Images/Non-EssentialLoads/dish_washer.png";
import iron from "../../Images/Non-EssentialLoads/iron.png";
import kitchen2 from "../../Images/Non-EssentialLoads/kitchen_2.png";
import washingMachine from "../../Images/Non-EssentialLoads/washing_machine.png";
import waterPump from "../../Images/Non-EssentialLoads/water_pump.png";
import { MdCall, MdLocationOn } from "react-icons/md";
import { MdEmail } from "react-icons/md";
import { FaWhatsapp } from "react-icons/fa";

// export const DomainUrl = `http://localhost:3000/api`;

export const DomainUrl = `https://janica.co.in/api`;

export const removeSpaces = (text) => {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-") // remove special chars
    .replace(/^-+|-+$/g, "");
};

export const EssentialLoadItems = [
  { id: 1, name: "Lights (Bulb)", icon: lampsIcon },
  { id: 2, name: "Lights (CFL)", icon: CflLampsIcon },
  { id: 3, name: "Lights (LED)", icon: LedLampsIcon },
  { id: 4, name: "Tubelights", icon: TubeLightIcon },
  { id: 5, name: " Fans", icon: fansIcon },
  { id: 6, name: "TV", icon: TelevisionIcon },
  { id: 7, name: "Kitchen Appliances", icon: KitchenIcon },
  { id: 8, name: " Desktop PCs", icon: DesktopIcon },
  { id: 9, name: " Laptops", icon: laptopIcon },
  { id: 10, name: "Servers", icon: ServersIcon },
  { id: 11, name: " IT peripherals", icon: itPeripheralsIcon },
  { id: 12, name: "Printers/Fax/Copiers", icon: Printers },
];
export const NonEssentialLoadItems = [
  { id: 13, name: "AC", icon: AC },
  { id: 14, name: "Water Pump", icon: waterPump },
  { id: 15, name: "Dish Washer", icon: dishWasher },
  { id: 16, name: "Electric geyzer", icon: geyser },
  { id: 17, name: "Washing Machine", icon: washingMachine },
  { id: 18, name: "Electric Iron", icon: iron },
  { id: 19, name: "Kitchen Appliances", icon: kitchen2 },
];

export const contactMethods = [
  {
    icon: <FaWhatsapp size={30} />,
    bgColor: "bg-green",
    text: "Get instant assistance from our experts via WhatsApp.",
    buttonText: "Chat With Us",
    to: "tel:+91 897761888",
  },
  // {
  //   icon: <MdCall size={30} />,
  //   bgColor: "bg-logoSecondBlue ",
  //   text: "Speak to our friendly support team for quick resolutions.",
  //   buttonText: "Call Us",
  //   // buttonColor: "bg-blue-600 hover:bg-blue-700",
  // },
  {
    icon: <MdEmail size={30} />,
    bgColor: " bg-logoSecondBlue",
    text: "Drop us a message, and we’ll get back to you as soon as possible.",
    buttonText: "Email Us",
    to: "mailto:info@janica.co.in",
  },
  {
    icon: <MdLocationOn size={30} />,
    bgColor: "bg-logoSecondBlue",
    text: "Visit our office for personalized assistance and inquiries.",
    buttonText: "Get Directions",
    to: "https://www.google.co.in/maps/@17.4816458,78.5587343,3a,90y,211.13h,92.17t/data=!3m7!1e1!3m5!1sG_1f65Gy9td9HbmS1E-k3A!2e0!6shttps:%2F%2Fstreetviewpixels-pa.googleapis.com%2Fv1%2Fthumbnail%3Fcb_client%3Dmaps_sv.tactile%26w%3D900%26h%3D600%26pitch%3D-2.1700000000000017%26panoid%3DG_1f65Gy9td9HbmS1E-k3A%26yaw%3D211.13!7i13312!8i6656?entry=ttu&g_ep=EgoyMDI1MDMxMC4wIKXMDSoASAFQAw%3D%3D",
  },
];

export const getDiscountPercentage = (actualPrice, offerPrice) => {
  if (actualPrice <= 0 || offerPrice < 0) {
    return 0;
  } else {
    const discount = actualPrice - offerPrice;
    const discountPercentage = (discount / actualPrice) * 100;
    return Math.round(discountPercentage);
  }
};
